import React, { FC } from 'react'
import classNames from 'classnames'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { setHelpDeskStartIndex } from 'out-game/actions/ui/helpdesk'

import { ChatProps, ChatViewMode } from './Chat.types'

import BellIcon from '../../assets/icons/bell-icon.svg'
import NoBellIcon from '../../assets/icons/nobell-icon.svg'
import CollapseIcon from '../../assets/icons/collapse.svg'
import CrossIcon from '../../assets/icons/cross-alt.svg'
import ChatIcon from '../../assets/icons/chat.svg'
import { Routes } from 'out-game/constants'

import ComplainIcon from '../../assets/icons/complain.svg'
import ComplainDarkIcon from '../../assets/icons/complain_dark.svg'

import BellDarkIcon from '../../assets/icons/bell-icon_dark.svg'
import NoBellDarkIcon from '../../assets/icons/nobell-icon_dark.svg'
import CollapseDarkIcon from '../../assets/icons/collapse_dark.svg'
import CrossDarkIcon from '../../assets/icons/cross-alt_dark.svg'
import ChatDarkIcon from '../../assets/icons/chat_dark.svg'
import Message from '../Message/Message'

import './Chat.scss'
import { useTranslationStrict } from 'out-game/hooks'

const Chat: FC<ChatProps> = ({
   listMessages,
   isNotificationsEnabled,
   onChangeSettings,
   user,
   chatListRef,
   onToggleChat,
   title = 'Флудильня',
   viewMode,
   changeViewMode,
   isGameChat
  }) => {

  const { t } = useTranslationStrict('chat')

  const history = useHistory()
  const dispatch = useDispatch()

  const onCollapse = () => {
    changeViewMode && changeViewMode(viewMode === ChatViewMode.full ? ChatViewMode.small : ChatViewMode.full)
  }

  const onComplain = () => {
    dispatch(setHelpDeskStartIndex(4))
    history.push(Routes.Helpdesk)
    onToggleChat()
  }

  const onChangeNotificationsSettings = () => {
    onChangeSettings(!isNotificationsEnabled)
  }

  const onWheel = (evt: WheelEvent) => {
    const elem = chatListRef.current
    if (!elem) return
    const offset = -evt.deltaY
    const crossingUpper = elem.scrollTop === 0 && offset > 0
    const crossingDown =
      elem.scrollHeight - elem.scrollTop === elem.clientHeight && offset < 0

    if (crossingUpper || crossingDown) {
      evt.preventDefault()
      evt.stopPropagation()
    }
  }

  const onMouseEnter = () => {
    const elem = chatListRef.current
    if (!elem) return
    elem.addEventListener('wheel', onWheel, { passive: false })
  }

  const onMouseLeave = () => {
    const elem = chatListRef.current
    if (!elem) return
    elem.removeEventListener('wheel', onWheel)
  }

  const chatClass = classNames('chat js-general-chat', {
    'chat_full': viewMode === ChatViewMode.full,
    'chat_small': viewMode === ChatViewMode.small
  })

  const chatTopClass = classNames('chat__top', {
    'chat__top_game': isGameChat
  })

  const chatTitleClass = classNames('chat__title', {
    'chat__title_game': isGameChat
  })

  const chatTitleClassHover = classNames('chat__title', 'chat__title_hover', {
    'chat__title_game': isGameChat
  })

  const bellClass = classNames('chat__bell', {
    chat__bell_notify: isNotificationsEnabled,
    'chat__bell_not-notify': !isNotificationsEnabled,
  })

  const collapseClass = classNames('chat__collapse', {
    chat__collapse_full: viewMode === ChatViewMode.full,
    'chat__collapse_small': viewMode === ChatViewMode.small,
  })

  const complainClass = classNames('chat__complain', {
    chat__complain_full: viewMode === ChatViewMode.full,
    'chat__complain_small': viewMode === ChatViewMode.small,
  })

  return (
    <div className={chatClass}>
      <div id='draggableChatHeader' className={chatTopClass}>
        <div className='chat__actions-left'>
          <button
            className={collapseClass}
            data-title={t(viewMode === ChatViewMode.full ? 'collapseChat' : 'expandChat')}
            onClick={onCollapse}
          >
            <img src={isGameChat ? CollapseDarkIcon : CollapseIcon} alt='Свернуть' />
          </button>
          <button
            className={complainClass}
            data-title={t('complain')}
            onClick={onComplain}
          >
            <img src={isGameChat ? ComplainDarkIcon : ComplainIcon} alt='Пожаловаться' />
          </button>
        </div>
        <p className={chatTitleClass}>{title} <img src={isGameChat ? ChatDarkIcon : ChatIcon} alt='Чат' /></p>
        <p className={chatTitleClassHover}>{t('holdToDrag')}</p>
        <div className='chat__actions-right'>
          <button
            className={bellClass}
            data-title={t('enableNotifications')}
            onClick={onChangeNotificationsSettings}
          >
            {/* TODO: translate */}
            {isNotificationsEnabled ?
              <img src={isGameChat ? BellDarkIcon : BellIcon} alt='Уведомления включены' /> :
              <img src={isGameChat ? NoBellDarkIcon : NoBellIcon} alt='Уведомления выключены' />}
          </button>
          <button
            className='chat__close'
            onClick={onToggleChat}
          >
            <img src={isGameChat ? CrossDarkIcon : CrossIcon} alt={t('common:close')} />
          </button>
        </div>
      </div>
      <div className='chat__list'>
        <ul
          className='chat__list-inner'
          ref={chatListRef}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          {listMessages.map((message) => {
            return !!message && (
              <li className='chat__list-item' key={message.id}>
                <Message message={message} user={user || ''} />
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default Chat
